export enum ArrivalStatus {
  GOING = 'GOING',
  UNPREDICTABLE = 'UNPREDICTABLE',
  ARRIVED = 'ARRIVED',
  RELEASED = 'RELEASED',
  CANCELED = 'CANCELED'
}
